import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">真实漫迷的真实评价，看看大家都在追什么</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/60 hover:border-primary-200/60 transition-colors"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-11 h-11 rounded-full object-cover"
                />
                <div>
                  <div className="font-semibold text-foreground-900 text-sm">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium">
                  <i className="ri-bookmark-line text-xs"></i>
                  {comment.manga}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}